import { COMPANY } from "../data/company";
import ArticleBody from "./ArticleBody";
import Breadcrumb from "./Breadcrumb";
import Faq from "./Faq";
import Related from "./Related";
import { formatDate } from "./format";
import "./templates.css";

/** A comparison: facts table in the body, then dated sources and a corrections line. */
export default function ComparePage({ entry, chunk }) {
  return (
    <article className="tpl tpl--compare">
      <div className="container tpl__inner">
        <Breadcrumb entry={entry} />
        <header className="tpl__head">
          <h1 className="t-display-2">{entry.h1}</h1>
          <p className="tpl__byline">Checked and updated {formatDate(entry.updated)}</p>
        </header>

        {chunk && (
          <>
            <ArticleBody html={chunk.html} slug={entry.path} lang={entry.lang} />
            {chunk.sources?.length > 0 && (
              <section className="tpl-section" aria-labelledby="tpl-sources">
                <h2 id="tpl-sources" className="tpl-section__title">
                  Sources
                </h2>
                <ul className="tpl-sources">
                  {chunk.sources.map((s) => (
                    <li key={s.url}>
                      <a href={s.url} rel="nofollow noopener noreferrer" target="_blank">
                        {s.label}
                      </a>
                      <span>, checked {formatDate(s.checked)}</span>
                    </li>
                  ))}
                </ul>
              </section>
            )}
            <p className="tpl-correction">
              Spotted a mistake? Email{" "}
              <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a>
            </p>
            <Faq items={chunk.faq} lang={entry.lang} />
            <Related paths={chunk.related} lang={entry.lang} />
          </>
        )}
      </div>
    </article>
  );
}
